<template>
    <div class="joinMatching">
        <div class="choice margin-top1">
            <el-form
                :inline="true"
                ref="ruleForm"
                label-width="85px"
            >
                <el-form-item label="状态" prop="typevalue">
                    <el-select v-model="ruleForm.type" placeholder="请选择">
                        <el-option
                            v-for="(item,index) in typelist"
                            :key="index"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开始日期" prop="starttime">
                    <el-date-picker
                        v-model="ruleForm.starttime"
                        align="right"
                        @change="startDate"
                        type="date"
                        placeholder="选择开始日期时间"
                        format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="结束日期" prop="endtime">
                    <el-date-picker
                        v-model="ruleForm.endtime"
                        align="right"
                        type="date"
                        @change="endDate"
                        placeholder="选择结束日期时间"
                        format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item class="searchInput">
                    <el-input v-model="ruleForm.input" style="width: 50%;" placeholder="订单号、订单ID、商品名称"></el-input>
                    <el-button type="primary" class="search" @click="search">搜索</el-button>
                    <el-button type="primary" class="search" @click="searchReset">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="order_list">
            <el-table border :data="tableData" style="width: 100%">
                <el-table-column align="center" label="订单号/订单ID" prop="order" width="250">
                    <template slot-scope="scope">
                        <p>订单号：{{scope.row.amazonOrderId}}</p>
                        <p>订单ID：{{scope.row.orderId}}</p>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="商品名称" prop="productFullName"></el-table-column>
                <el-table-column align="center" label="商品图片" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.imagesList!==null">
                        <el-popover trigger="hover" placement="right" style="float: left;">
                                <img :src="scope.row.imagesList[0]" alt style="width:500px;height:500px;" />
                                <div slot="reference">
                                    <img :src="scope.row.imagesList[0]" alt style="width:80px;height:80px;"/>
                                </div>
                        </el-popover>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="使用数量" prop="useCount"></el-table-column>
                <el-table-column align="center" label="价格">
                    <template slot-scope="scope">
                        {{(scope.row.useCount)*(scope.row.currentPrice)}}
                    </template>
                </el-table-column>
                <el-table-column align="center" label="下单时间" prop="createTime"></el-table-column>
                <el-table-column align="center" label="状态" prop="">
                    <template slot-scope="scope">
                        <span v-if="scope.row.onLineStatus == 0">未上架</span>
                        <span v-if="scope.row.onLineStatus == 1">上架</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="ToView(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-dialog title="查看商城订单" :visible.sync="dialogVisible" width="60%">
        <div class="box">
            <img :src="this.ViewData.images" alt="" style="width:150px;height:150px;">
            <div class="inbox">
                <p>商品全称：{{this.ViewData.productFullName}}</p>
                <p>商品描述：{{this.ViewData.productDescription}}</p>
                <p>使用数量：{{this.ViewData.useCount}}</p>
                <p>订单价格：{{(this.ViewData.useCount)*(this.ViewData.currentPrice)}}</p>
            </div>
        </div>
        <el-divider></el-divider>
        <div class="box" style="margin-top:20px;" v-for="item in this.boxList">
            <img :src="item.imageUrl" alt="" style="width:150px;height:150px;">
            <div class="inbox">
                <p>亚马逊订单号：{{item.amazonOrderId}}</p>
                <p>标题：{{item.title}}</p>
                <p>SKU：{{item.sellerSKU}}</p>
                <p>数量：{{item.quantity}}</p>
            </div>
        </div>
        </el-dialog>

        <div class="page">
                <el-pagination
                    style="margin-right:200px;"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[50, 100, 200, 400]"
                    :page-size="pagesize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                ></el-pagination>
            </div>
    </div>
</template>
<script>
import { ajaxPost, Baseurl } from "@/api/api/api";
export default {
    name: "commoditieslist",
    data() {
        return {
            str:"",
            dialogVisible:false,
            ruleForm: {
                type: "",
                starttime:"",
                endtime:"",
                input:""
            },
            typelist: [
                {
                    value: 0,
                    label: "未上架"
                },
                {
                    value: 1,
                    label: "上架"
                },
            ],
            currentPage: 1,
            pagesize: 20,
            size: 20,
            total: 0,
            tableData: [],
            ViewData:"",
            boxList:[],
        };
    },
    created(){
        this.str = JSON.parse(localStorage.getItem("role"));
        this.search()
    },
    methods: {
        search(){
            var obj = {
                page:this.currentPage,
                size:this.size,
                startTimeString:this.ruleForm.starttime,
                endTimeString:this.ruleForm.endtime,
                searchString:this.ruleForm.input,
                onLineStatus:this.ruleForm.type,
            }
            ajaxPost(Baseurl + "inventoryController/selectOnLineInventorysOperate", obj).then(res => {
                if(res.data.code == 200){
                    this.tableData = res.data.data.list
                    this.total = res.data.data.total
                }
            });
        },
        searchReset(){
            this.ruleForm.type = ""
            this.ruleForm.starttime = ""
            this.ruleForm.endtime = ""
            this.ruleForm.input = ""
            this.search()
        },
        ToView(val){
            console.log(val)
            this.dialogVisible = true
            this.ViewData = val
            ajaxPost(Baseurl + "inventoryController/selectOrderInfoByOrderId", {orderId:this.ViewData.orderId}).then(res => {
                if(res.data.code == 200){
                    this.boxList = res.data.data
                }
            });
        },
        //选择开始日期
        startDate(val) {
            var d = new Date(val);
            var datetime =
                d.getFullYear() +
                "-" +
                (d.getMonth() + 1) +
                "-" +
                d.getDate() +
                " 00:00:00";
            this.ruleForm.starttime = datetime;
        },
        //选择结束日期
        endDate(val) {
            var d = new Date(val);
            var datetime =
                d.getFullYear() +
                "-" +
                (d.getMonth() + 1) +
                "-" +
                d.getDate() +
                " 23:59:59";
            this.ruleForm.endtime = datetime;
        },
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.size = val;
            this.search()
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.currentPage = val;
            this.search()
        },
    }
};
</script>
<style lang="scss">
.joinMatching {
    width: 98%;
    position: relative;
    .el-form-item__label {
        text-align: center;
    }
    .searchInput .el-form-item__content{
        width: 600px;
    }
    .left {
        overflow: hidden;
        float: left;
        width: 20%;
    }
    h3 {
        line-height: 45px;
    }
    .search {
        margin-left: 10px;
    }
    label {
        font-weight: 600;
        margin-right: 5px;
    }
    .el-table {
        overflow: initial;
    }
    .el-table__body-wrapper {
        overflow: initial;
    }
    a {
        color: #409eff;
    }
    .scope_img {
        width: 50px;
        height: 50px;
        float: left;
        img {
            width: 100%;
            height: 100%;
        }
    }
    .page {
        position: fixed;
        width: 100%;
        bottom: 0;
        background-color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 50px;
    }
    .box{
        display: flex;
        justify-content: left;
    }
    .inbox{
        margin-left:20px;
    }
    .inbox p {
        line-height: 37px;
    }
}
</style>
